"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var VideoLogEvent_1 = require("../statscollector/VideoLogEvent");

var BaseTask_1 = require("./BaseTask");
/*
 * [[AttachMediaInputTask]] adds audio and video input to peer connection.
 */


var AttachMediaInputTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(AttachMediaInputTask, _BaseTask_1$default);

  var _super = _createSuper(AttachMediaInputTask);

  function AttachMediaInputTask(context) {
    var _this;

    _classCallCheck(this, AttachMediaInputTask);

    _this = _super.call(this, context.logger);
    _this.context = context;
    _this.taskName = 'AttachMediaInputTask';
    return _this;
  }

  _createClass(AttachMediaInputTask, [{
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this2 = this;

        var transceiverController, audioInput, audioTracks, senders, videoInput, videoTracks, videoTrack, encodingParam, _senders;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                transceiverController = this.context.transceiverController;
                transceiverController.setPeer(this.context.peer);
                transceiverController.setupLocalTransceivers();
                audioInput = this.context.activeAudioInput;

                if (!audioInput) {
                  _context.next = 17;
                  break;
                }

                audioTracks = audioInput.getAudioTracks();

                if (!this.context.browserBehavior.requiresUnifiedPlan()) {
                  _context.next = 12;
                  break;
                }

                this.context.logger.info('attaching audio track to peer connection (unified-plan)');
                _context.next = 10;
                return transceiverController.setAudioInput(audioTracks.length ? audioTracks[0] : null);

              case 10:
                _context.next = 15;
                break;

              case 12:
                this.context.logger.info('attaching audio track to peer connection (plan-b)'); // @ts-ignore

                senders = this.context.peer.getSenders();
                audioInput.getAudioTracks().forEach(function (track) {
                  if (!senders.find(function (sender) {
                    return sender.track.id === track.id;
                  })) {
                    // unclear why this does not deal with the case of removing
                    // an existing track as we do in attachVideoInput
                    // @ts-ignore
                    _this2.context.localAudioSender = _this2.context.peer.addTrack(track, audioInput);
                  }
                });

              case 15:
                _context.next = 20;
                break;

              case 17:
                _context.next = 19;
                return transceiverController.setAudioInput(null);

              case 19:
                this.context.logger.info('no audio track');

              case 20:
                videoInput = this.context.activeVideoInput;

                if (!videoInput) {
                  _context.next = 37;
                  break;
                }

                videoTracks = videoInput.getVideoTracks();
                videoTrack = videoTracks.length ? videoTracks[0] : null;

                if (!this.context.browserBehavior.requiresUnifiedPlan()) {
                  _context.next = 31;
                  break;
                }

                this.context.logger.info('attaching video track to peer connection (unified-plan)');
                _context.next = 28;
                return transceiverController.setVideoInput(videoTrack);

              case 28:
                if (this.context.enableSimulcast && this.context.videoUplinkBandwidthPolicy) {
                  encodingParam = this.context.videoUplinkBandwidthPolicy.chooseEncodingParameters();
                  transceiverController.setEncodingParameters(encodingParam);
                }

                _context.next = 34;
                break;

              case 31:
                this.context.logger.info('attaching video track to peer connection (plan-b)'); // @ts-ignore

                _senders = this.context.peer.getSenders();

                if (!_senders.find(function (sender) {
                  return sender.track && sender.track.id === videoTracks[0].id;
                })) {
                  if (this.context.localVideoSender) {
                    // @ts-ignore
                    this.context.peer.removeTrack(this.context.localVideoSender);
                    this.context.localVideoSender = null;
                  }

                  this.context.localVideoSender = this.context.peer.addTrack(videoTracks[0], videoInput);
                }

              case 34:
                if (videoTrack) {
                  this.context.statsCollector.logVideoEvent(VideoLogEvent_1.default.InputAttached, this.context.videoDeviceInformation);
                  this.context.videoInputAttachedTimestampMs = Date.now();
                }

                _context.next = 41;
                break;

              case 37:
                _context.next = 39;
                return transceiverController.setVideoInput(null);

              case 39:
                this.context.logger.info('no video track');

                if (this.context.localVideoSender) {
                  this.context.logger.info('removing track from peer'); // @ts-ignore

                  this.context.peer.removeTrack(this.context.localVideoSender);
                  this.context.localVideoSender = null;
                }

              case 41:
                this.context.videoSubscriptions = transceiverController.updateVideoTransceivers(this.context.videoStreamIndex, this.context.videosToReceive);

              case 42:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return AttachMediaInputTask;
}(BaseTask_1.default);

exports.default = AttachMediaInputTask;